import { Grid } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { AppBox, AppTypography, AppButton } from 'components'
import { ApiQueryKeys, ProfileModules, appRoutes } from 'globals/constants'
import { useSnackbar } from 'notistack'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ChangeMembershipResponse, MembershipApi, SessionModel } from 'sdk'
import { useAppDispatch } from 'store/app.store'
import { AuthSliceSelector, setMemberships, setOpenedProfileModule, setSession } from 'store/slices'

interface Props {}

export const PausedMessage: FC<Props> = () => {
  const { CurrentUser } = useSelector(AuthSliceSelector)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const membershipApi = new MembershipApi()
  const { enqueueSnackbar } = useSnackbar()

  const handleRedirect = () => {
    dispatch(setOpenedProfileModule(ProfileModules.Billing))
    navigate(appRoutes.profile.path)
  }
  const { mutate: resumeMembership, isPending: isResuming } = useMutation({
    mutationKey: [ApiQueryKeys.memberships.ResumeMembership],
    mutationFn: () => membershipApi.ResumeMembership(),
    onSuccess: (data: ChangeMembershipResponse) => {
      if (data) {
        dispatch(setMemberships(data.Memberships))
        const copy: SessionModel = JSON.parse(JSON.stringify(CurrentUser))
        copy.Status = data.UserStatus
        dispatch(setSession(copy))
        enqueueSnackbar('Membership changed successfully', { variant: 'success' })
      }
    },
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
  })

  return (
    <AppBox height={'91vh'} alignContent={'center'}>
      <Grid container justifyContent={'center'}>
        <Grid item xs={4}>
          <AppBox backgroundColor="white" borderRadius={6} border={1} borderColor={'grey.200'} padding={2}>
            <AppBox borderBottom={1} borderColor={'grey.200'} paddingBottom={1}>
              <AppTypography fontSize={32} fontWeight={'bold'}>
                {CurrentUser?.FirstName ?? ''}, your plan was paused
              </AppTypography>
            </AppBox>
            <AppTypography fontSize={16} fontWeight={400} color={'grey.500'} paddingTop={2}>
              It looks like you paused your paid plan the last time you were here. Let’s get your account back up and
              running. Just click the Resume Plan button to pick up where you left off.
            </AppTypography>
            <AppBox textAlign={'right'} paddingTop={2}>
              <AppBox display={'flex'} alignItems={'center'} gap={1}>
                <AppButton variant="outlined" size="small" onClick={() => resumeMembership()} isLoading={isResuming}>
                  Resume Plan
                </AppButton>
                <AppButton variant="contained" size="small" onClick={handleRedirect}>
                  Billing & Plans
                </AppButton>
              </AppBox>
            </AppBox>
          </AppBox>
        </Grid>
        <Grid item xs={2}>
          <img
            src="/images/dashboard/old-subscription-cancelled/old-subscription-cancelled.png"
            alt="old-cancelled-message"
          />
        </Grid>
      </Grid>
    </AppBox>
  )
}
